import { Badge } from '~/components/ui/badge';
import { cn } from '~/lib/utils';

type StatusType = 'Partial' | 'Submitted' | 'Qualified';

const STATUS_STYLES: Record<StatusType, string> = {
  Partial: 'bg-orange-100 text-orange-800 hover:bg-orange-100',
  Submitted: 'bg-green-100 text-green-800 hover:bg-green-100',
  Qualified: 'bg-green-100 text-green-800 hover:bg-green-100',
};

interface IStatusBadgeProps {
  status: StatusType;
}

export const StatusBadge = ({ status }: IStatusBadgeProps) => {
  return (
    <Badge variant="secondary" className={cn('font-medium', STATUS_STYLES[status])}>
      {status}
    </Badge>
  );
};
